import { useCallback } from 'react';

import { useLedgerSummaryByIdQuery } from '../data-access';
import { type WalletLedgerSummaryInfo } from '../models';

/**
 * @returns An array of all WalletLedger objects from the wallet data.
 */
export const useLedgerSummaryNonTradableDetails = (ledgerId: string) => {
	const walletLedgerSummaryNonTradableDetailsReducer = useCallback(
		(data: undefined | WalletLedgerSummaryInfo) => data?.nonTradableDetails ?? [],
		[]
	);
	const {
		data: ledgerSummary,
		error,
		isLoading,
		refetch
	} = useLedgerSummaryByIdQuery(ledgerId, walletLedgerSummaryNonTradableDetailsReducer);
	const nonTradableDetails = ledgerSummary || [];

	return { error, isLoading, nonTradableDetails, refetch };
};
